import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { JhiEventManager } from 'ng-jhipster';
import { ConfirmationModelService } from 'src/app/shared/confirmation-modal/confirmation-model.service';
import { FutureDataType } from 'src/app/shared/model/future_data_type.model';
import { IInsuranceCompanyMySuffix } from 'src/app/shared/model/insurance-company-my-suffix.model';
import { LanguageChangeService } from 'src/app/shared/services/language-change.service';
import { InsuranceCompanyMySuffixService } from './insurance-company-my-suffix.service';




@Component({
    selector: 'jhi-insurance-company-my-suffix-delete-dialog',
    templateUrl: './insurance-company-my-suffix-delete-dialog.component.html'
})
export class InsuranceCompanyMySuffixDeleteDialogComponent {
    insuranceCompany: IInsuranceCompanyMySuffix;
    futureStatus: boolean = false;
    isConfirmed: boolean = false;

    constructor(
        private insuranceCompanyService: InsuranceCompanyMySuffixService,
        public activeModal: NgbActiveModal,
        private eventManager: JhiEventManager,
        private languageChangeService: LanguageChangeService,
        private futureRecordService: ConfirmationModelService,
        private activatedRoute: ActivatedRoute,
        
    ) {
         this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            const refresh = paramMap.get('refresh');
            if (refresh) {
                 
                this.languageChangeService.refreshLanguage();
            }
    });
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }

    setFutureStatus(futureStatus) {
        this.futureStatus = futureStatus;
    }

    confirmDelete(id: number) {
        this.isConfirmed = true;
        if (this.futureStatus) {
            this.updateExistedFutureRecordStatus(id);
        }
        this.insuranceCompanyService.delete(id).subscribe(response => {
            if(response)
            this.eventManager.broadcast({
                name: 'insuranceCompanyListModification',
                content: 'Deleted an insuranceCompany'
            });
            this.activeModal.dismiss(true);
        },(err)=>{
            this.activeModal.dismiss(true);
        });
    }

    updateExistedFutureRecordStatus(id: number) {
        this.futureRecordService.updateExistedFutureRecordStatus({
            masterId: this.insuranceCompany.id,
            futureDataType: FutureDataType.INSURANCE_COMPANY.valueOf(),
            fromEffectiveDateFormatted: this.insuranceCompany.fromEffectiveDate,
            masterStatus : this.insuranceCompany.activeStatus == 'ACTIVE' ? 'IN_ACTIVE' : 'ACTIVE',
        }).subscribe(response => {
            console.log(response.body);
        });
    }
}

@Component({
    selector: 'jhi-insurance-company-my-suffix-delete-popup',
    template: ''
})
export class InsuranceCompanyMySuffixDeletePopupComponent implements OnInit, OnDestroy {
    private ngbModalRef: NgbModalRef;

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private modalService: NgbModal,
        private languageChangeService: LanguageChangeService
    ) {}

    ngOnInit() {
        this.activatedRoute.data.subscribe(({ insuranceCompany }) => {
            setTimeout(() => {
                this.ngbModalRef = this.modalService.open(InsuranceCompanyMySuffixDeleteDialogComponent as Component, {
                    size: 'lg',
                    backdrop: 'static'
                });
                this.ngbModalRef.componentInstance.insuranceCompany = insuranceCompany;
                this.ngbModalRef.result.then(
                    result => {
                        //this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true, queryParamsHandling: 'merge' });
                        this.router.navigateByUrl('', { skipLocationChange: true }).then(() => this.router.navigate(['/data-management/insurance-company']));
                        this.ngbModalRef = null;
                    },
                    reason => {
                        //this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true, queryParamsHandling: 'merge' });
                        this.router.navigateByUrl('', { skipLocationChange: true }).then(() => this.router.navigate(['/data-management/insurance-company']));
                        this.ngbModalRef = null;
                    }
                );
            }, 0);
        });
        
       
    }

    ngOnDestroy() {
        this.ngbModalRef = null;
    }
}
